import { defineSemanticTokens } from '@chakra-ui/react';

export const semanticTokens = defineSemanticTokens({
  colors: {
    bg: {
      primary: { value: { base: '#ffffff', _dark: '{colors.gray.950}' } },
      secondary: { value: { base: '{colors.gray.50}', _dark: '{colors.gray.900}' } },
      tertiary: { value: { base: '{colors.gray.100}', _dark: '{colors.gray.800}' } },
      active: { value: { base: '{colors.gray.50}', _dark: '{colors.gray.800}' } },
      disabled: { value: { base: '{colors.gray.100}', _dark: '{colors.gray.800}' } },
      overlay: { value: { base: 'rgba(16, 24, 40, 0.70)', _dark: 'rgba(0, 0, 0, 0.70)' } },
    },
    surface: {
      primary: { value: { base: '#ffffff', _dark: '{colors.gray.900}' } },
      secondary: { value: { base: '{colors.gray.50}', _dark: '{colors.gray.800}' } },
      elevated: { value: { base: '#ffffff', _dark: '{colors.gray.800}' } },
    },
    border: {
      primary: { value: { base: '{colors.gray.300}', _dark: '{colors.gray.700}' } },
      secondary: { value: { base: '{colors.gray.200}', _dark: '{colors.gray.800}' } },
      disabled: { value: { base: '{colors.gray.200}', _dark: '{colors.gray.800}' } },
      brand: { value: { base: '{colors.brand.300}', _dark: '{colors.brand.500}' } },
    },
    text: {
      primary: { value: { base: '{colors.gray.900}', _dark: '{colors.gray.50}' } },
      secondary: { value: { base: '{colors.gray.600}', _dark: '{colors.gray.300}' } },
      tertiary: { value: { base: '{colors.gray.500}', _dark: '{colors.gray.400}' } },
      placeholder: { value: { base: '{colors.gray.400}', _dark: '{colors.gray.500}' } },
      disabled: { value: { base: '{colors.gray.400}', _dark: '{colors.gray.600}' } },
      brand: { value: { base: '{colors.brand.700}', _dark: '{colors.brand.300}' } },
      onBrand: { value: '#ffffff' },
    },
    interactive: {
      default: { value: { base: '{colors.brand.600}', _dark: '{colors.brand.500}' } },
      hover: { value: { base: '{colors.brand.700}', _dark: '{colors.brand.400}' } },
      active: { value: { base: '{colors.brand.800}', _dark: '{colors.brand.300}' } },
      disabled: { value: '{colors.gray.300}' },
    },
    status: {
      success: {
        bg: { value: { base: '{colors.success.50}', _dark: 'rgba(18, 183, 106, 0.12)' } },
        text: { value: { base: '{colors.success.700}', _dark: '{colors.success.300}' } },
        border: { value: { base: '{colors.success.300}', _dark: '{colors.success.500}' } },
      },
      error: {
        bg: { value: { base: '{colors.error.50}', _dark: 'rgba(240, 68, 56, 0.12)' } },
        text: { value: { base: '{colors.error.700}', _dark: '{colors.error.300}' } },
        border: { value: { base: '{colors.error.300}', _dark: '{colors.error.500}' } },
      },
      warning: {
        bg: { value: { base: '{colors.warning.50}', _dark: 'rgba(247, 144, 9, 0.12)' } },
        text: { value: { base: '{colors.warning.700}', _dark: '{colors.warning.300}' } },
        border: { value: { base: '{colors.warning.300}', _dark: '{colors.warning.500}' } },
      },
      neutral: {
        bg: { value: { base: '{colors.gray.50}', _dark: '{colors.gray.800}' } },
        text: { value: { base: '{colors.gray.700}', _dark: '{colors.gray.300}' } },
        border: { value: { base: '{colors.gray.300}', _dark: '{colors.gray.700}' } },
      },
    },
    chart: {
      candleUp: { value: { base: '#2e7d6f', _dark: '#4ade9a' } },
      candleDown: { value: { base: '#c4554e', _dark: '#f87171' } },
      volume: { value: { base: '{colors.gray.200}', _dark: '{colors.gray.700}' } },
      grid: { value: { base: '{colors.gray.100}', _dark: '{colors.gray.800}' } },
      crosshair: { value: '{colors.gray.400}' },
      sma20: { value: '{colors.brand.400}' },
      sma50: { value: '{colors.warning.500}' },
    },
  },
  shadows: {
    xs: { value: { base: '0 1px 2px rgba(16, 24, 40, 0.05)', _dark: '0 1px 2px rgba(0, 0, 0, 0.20)' } },
    sm: { value: { base: '0 1px 3px rgba(16, 24, 40, 0.10), 0 1px 2px rgba(16, 24, 40, 0.06)', _dark: '0 1px 3px rgba(0, 0, 0, 0.30)' } },
    md: { value: { base: '0 4px 8px -2px rgba(16, 24, 40, 0.10), 0 2px 4px -2px rgba(16, 24, 40, 0.06)', _dark: '0 4px 8px rgba(0, 0, 0, 0.30)' } },
    lg: { value: { base: '0 12px 16px -4px rgba(16, 24, 40, 0.08), 0 4px 6px -2px rgba(16, 24, 40, 0.03)', _dark: '0 12px 16px rgba(0, 0, 0, 0.40)' } },
  },
});
